import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessList = _resolveComponent("BusinessList")!

  return (_openBlock(), _createBlock(_component_BusinessList, {
    tabPanelData: _ctx.tabList,
    pageTypeIn: "RECEIVED",
    marketFeeCanCommand: false,
    canCommand: false,
    FilterFieldProps: _ctx.FilterField,
    businessTypeName: "TABLE_RECEIVED_BUSINESS",
    HiddenFieldFunProps: (item) => '开票状态、开票日期、发票号码、发票金额、紧急程度、预计完成天数、维修类型、业务分类'.split('、').some(fieldName => fieldName === item.fieldName)
  }, null, 8, ["tabPanelData", "FilterFieldProps", "HiddenFieldFunProps"]))
}